export enum StatusType {
	DEBUG = "DEBUG",
	INTERFACE = "INTERFACE",
	TOAST = "TOAST",
}
